import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import config from "@/config";

Vue.use(Vuex);

const News = {
    namespaced: true,
    state: {
        types: [],
        articles: [],
        article_id: localStorage.getItem('article_id'),
        article: {}
    },
    getters: {
        all: state => state.articles || [],
        current: state => state.article || null,
        article_id: state => state.cur_article || null,
        article_types: state => state.types || [],
    },
    mutations: {
        setArticle(state, curent) {
            state.article = curent;
            state.article_id = curent.id;
            localStorage.setItem('article_id', curent.id);
        },
        setArticleId(state, id) {
            state.article_id = id;
            localStorage.setItem('article_id', id);
        },
        pushArticle(state, article) {
            state.articles.push(article);
        },
        removeArticle(state, id) {
            var idx = state.articles.findIndex(article => article.id == id);
            state.articles.splice(idx, 1);
        },
        setNews(state, all_news) {
            state.articles = all_news;
        },
        removeArticleImage(state, id) {
            var idx = state.article.images.findIndex(img => img.id == id);
            state.article.images.splice(idx, 1);
        },
        setArticleTypes(state, curent) {
            state.types = curent;
        },
    },
    actions: {
        fetchNews({ rootState, commit }) {
            return new Promise((resolve, reject) => {
                axios.get(config.API_URL + '/projects/' + rootState.project.uuid + '/articles')
                    .then(response => {
                        commit('setNews', response.data);
                        resolve();
                    })
                    .catch(err => {
                        reject(err);
                    })
            });
        },
        create({ rootState, commit }, article) {
            //console.log(article);
            return new Promise((resolve, reject) => {
                axios.post(config.API_URL + '/articles', { project: rootState.project.uuid, title: article.title, article_type:article.type })
                    .then(response => {
                        commit('pushArticle', response.data);
                        commit('setArticle', response.data);
                        resolve(response.data);
                    })
                    .catch(err => {
                        reject(err);
                    })
            });
        },
        saveArticle({ state, commit }) {
            return new Promise((resolve, reject) => {
                axios.put(config.API_URL + '/articles/' + state.article.id, { ...state.article })
                    .then(response => {
                        //console.log(response.data);
                        //commit('setArticle', response.data);
                        resolve();
                    })
                    .catch(err => {
                        reject(err);
                    })
            });
        },
        fetchArticle({ commit }, article_id) {
            return new Promise((resolve, reject) => {
                axios.get(config.API_URL + '/articles/' + article_id)
                    .then(response => {
                        commit('setArticle', response.data);
                        resolve();
                    })
                    .catch(err => {
                        reject(err);
                    })
            });
        },
        fetchArticleTypes({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(config.API_URL + '/article/types')
                    .then(response => {
                        commit('setArticleTypes', response.data);
                        resolve();
                    })
                    .catch(err => {
                        reject(err);
                    })
            });
        },
        removeImage({ state, commit }, image_id) {
            return new Promise((resolve, reject) => {
                axios.delete(config.API_URL + '/images/' + image_id)
                    .then(response => {
                        commit('removeArticleImage', image_id);
                        resolve();
                    })
                    .catch(err => {
                        reject(err);
                    })
            });
        },
        deleteArticle({ state, commit }, article_id) {
            return new Promise((resolve, reject) => {
                axios.delete(config.API_URL + '/articles/' + article_id)
                    .then(response => {
                        commit('removeArticle', article_id);
                        resolve();
                    })
                    .catch(err => {
                        reject(err);
                    })
            });
        }
    }
}

export default News;